import { centerable as s } from "../decorators/centerable.js";
import { uploadable as o } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as i } from "../../constants.js";
import { defineAttrs as m } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const e = {
  element: i.imageText,
  image: `${i.imageText}-image`,
  imageContainer: `${i.imageText}-image-container`,
  description: `${i.imageText}-description`,
  textContainer: `${i.imageText}-text-container`,
  title: `${i.imageText}-title`
}, c = m({
  type: { default: "imageText" },
  imageUrl: { default: "" },
  text: { default: "" },
  title: { default: "" }
}), T = s(
  o({
    inline: !1,
    attrs: c,
    group: "block",
    parseDOM: [
      {
        tag: e.element,
        getAttrs(t) {
          const r = t.querySelector(`.${e.image}`), a = t.querySelector(`.${e.title}`), n = t.querySelector(`.${e.description}`);
          return {
            imageUrl: r.getAttribute("src"),
            title: a.textContent,
            text: n.textContent
          };
        }
      }
    ],
    toDOM(t) {
      const r = t.attrs, { imageUrl: a, text: n, title: l } = r;
      return [
        "div",
        {
          class: e.element,
          "data-type": "imageText"
        },
        [
          "div",
          {
            class: e.imageContainer
          },
          [
            "img",
            {
              src: a,
              alt: n,
              class: e.image
            }
          ]
        ],
        [
          "div",
          {
            class: e.textContainer
          },
          [
            "div",
            {
              class: e.title
            },
            ["b", {}, l]
          ],
          [
            "div",
            {
              class: e.description
            },
            n
          ]
        ]
      ];
    }
  })
);
function f(t) {
  t.querySelectorAll(`.${i.imageText}`).forEach((a) => {
    a.remove();
  });
}
export {
  f as cleanImageTextFromElement,
  e as imageTextCssClasses,
  T as imageTextSpec
};
